import moment from "moment";
import { AccessObj, GetCurrentUserTypeInt, GetLoggedUserID, GetLoggedUserUUID, GetOwnerOfLoggedMcUUID, UserList, views } from "./constants";
import { RefId } from "./res/RefId";

export function getDayName(passedDate, locale = 'fr-FR') {

  const dt = new Date(passedDate.day)
  return dt.toLocaleDateString(locale, { weekday: 'long' });
}


export function getDayNameDate(passedDate, locale = 'fr-FR', long = false, seperate = false) {

  const dt = new Date(passedDate)
  return seperate ?
    { day: dt.toLocaleDateString(locale, { weekday: long ? 'long' : 'short' }), date: dt.toLocaleDateString(locale, { day: 'numeric' }) }
    : dt.toLocaleDateString(locale, { weekday: long ? 'long' : 'short', day: 'numeric' });
}

export const getAbre = (name) => {
  const nameArr = name?.split?.(' ')
  if (nameArr?.length === 1) {
    return `${name?.charAt?.(0)}${name?.charAt?.(name?.length - 1)}`
  }
  return name ? `${name?.charAt?.(0)}${nameArr?.[1].charAt(0)}` : ''
}


export function addMinutes(date, minutes) {
  return new Date(date.getTime() + minutes * 60000);
}

export function getStartOfWeek(date) {
  const currentDate = new Date(date);
  const dayOfWeek = currentDate.getDay(); // 0 (Sunday) to 6 (Saturday)
  const diff = currentDate.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1); // Adjust for Monday as the start of the week
  const startOfWeek = new Date(currentDate.setDate(diff));
  startOfWeek.setHours(0, 0, 0, 0); // Set to midnight
  return startOfWeek;
}

export function addDays(date, noofDays) {

  let currentDate = new Date(date)
  currentDate.setDate(currentDate.getDate() + parseInt(noofDays))
  return currentDate
}

export function shadeColor(color, percent) {
  if (typeof color != 'string') return
  var R = parseInt(color.substring(1, 3), 16);
  var G = parseInt(color.substring(3, 5), 16);
  var B = parseInt(color.substring(5, 7), 16);

  R = parseInt(R * (100 + percent) / 100);
  G = parseInt(G * (100 + percent) / 100);
  B = parseInt(B * (100 + percent) / 100);

  R = (R < 255) ? R : 255;
  G = (G < 255) ? G : 255;
  B = (B < 255) ? B : 255;

  R = Math.round(R)
  G = Math.round(G)
  B = Math.round(B)

  var RR = ((R.toString(16).length == 1) ? "0" + R.toString(16) : R.toString(16));
  var GG = ((G.toString(16).length == 1) ? "0" + G.toString(16) : G.toString(16));
  var BB = ((B.toString(16).length == 1) ? "0" + B.toString(16) : B.toString(16));

  // return "#" + RR + GG + BB;
  return color
}

export const time24 = (startTime = '00:00', interval = 5) => {
  const [startHours, startMinutes] = startTime.split(':').map(Number);
  const startIndex = startHours * 60 / interval + startMinutes / interval;
  const time = Array.from({ length: 24 * 60 / interval - startIndex }, (_, i) => {
    const hours = Math.floor((i + startIndex) * interval / 60);
    const minutes = Math.round((i + startIndex) * interval % 60);
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  });
  if (startTime != '00:00') {
    time.splice(0, 1)
  }
  return time;
}


export const time24new = (startTime = '00:00', interval = 5) => {
  const [startHours, startMinutes] = startTime.split(':').map(Number);
  const startIndex = startHours * 60 / interval + startMinutes / interval;
  const time = Array.from({ length: 24 * 60 / interval - startIndex }, (_, i) => {
    const hours = Math.floor((i + startIndex + 1) * interval / 60);

    const minutes = Math.round((i + startIndex) * interval % 60);
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  });

  return time;
}

export const formatDateFR = (date, lang = "fr", length = 'long') => {
  let dateObj = new Date(date);
  let options = { weekday: length, year: 'numeric', month: length, day: 'numeric' };
  let formattedDate = dateObj.toLocaleDateString(lang, options)
  return formattedDate
}

export const isOlderThan = (dob, age) => {
  const date = dob?.split?.('/')
  if (!(Array.isArray(date)) || date.length < 3 || date?.[2]?.length < 4) {
    return true
  }
  const newDOB = new Date()
  newDOB.setDate(parseInt(date[0]))
  newDOB.setMonth(parseInt(date[1]) - 1)
  newDOB.setFullYear(parseInt(date[2]))
  let today = new Date();
  let ageTillToday = new Date(today.getFullYear() - age, today.getMonth(), today.getDate());
  return newDOB <= ageTillToday;
}

export const formatTime = (date, lang = "fr") => {
  const options = { hour: 'numeric', minute: 'numeric', hour12: true };
  const formatter = new Intl.DateTimeFormat(lang, options);
  return formatter.format(date);
}

export const getTime24FromDate = (dateTime) => {
  const stringTime = new Date(dateTime);
  const hours = stringTime.getHours();
  const minutes = stringTime.getMinutes();

  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
}

export const calculateDurationMin = (startTime, endTime) => {
  const start = new Date(`1970-01-01T${startTime}Z`);
  const end = new Date(`1970-01-01T${endTime}Z`);
  let diff = end - start;
  if (diff < 0) {
    return "Minus";
  }
  const minutes = diff / 1000 / 60;

  return `${minutes}`;
}
// Example (11:00 - 12:00 | 1hr 0min)
export function convertDatesToTimeRange(startDateString, endDateString) {
  const startDate = new Date(startDateString);
  const endDate = new Date(endDateString);

  // Ensure start date comes before end date
  if (startDate > endDate) {
    // [startDate, endDate] = [endDate, startDate];
    return ``
  }

  // Extract hours and minutes
  const startHour = startDate.getHours();
  const startMinutes = startDate.getMinutes();
  const endHour = endDate.getHours();
  const endMinutes = endDate.getMinutes();

  // Calculate the difference in hours and minutes
  const timeDiffHours = Math.floor(Math.abs(endDate - startDate) / (1000 * 60 * 60));
  const timeDiffMinutes = Math.floor(Math.abs(endDate - startDate) / (1000 * 60)) % 60;

  // Format the start and end time strings
  const startTime = `${startHour.toString().padStart(2, '0')}:${startMinutes.toString().padStart(2, '0')}`;
  const endTime = `${endHour.toString().padStart(2, '0')}:${endMinutes.toString().padStart(2, '0')}`;

  // Return the time range with duration
  return `${startTime} - ${endTime} (${timeDiffHours ? timeDiffHours.toString() == '1' ? '1hr' : `${timeDiffHours}hrs` : ''}${timeDiffHours > 0 && timeDiffMinutes > 0 ? ' ' : ''}${timeDiffMinutes > 0 ? `${timeDiffMinutes}mins` : ''})`;
}

// Current age
export function calculateAge(birthDate) {
  // Get today's date
  const today = new Date();

  // Parse the birth date
  if (typeof birthDate === 'string') {
    birthDate = new Date(birthDate);
  }

  // Calculate the age in milliseconds
  const ageInMilliseconds = today - birthDate;

  // Convert milliseconds to years
  const ageInMonth = Math.floor(ageInMilliseconds / (1000 * 60 * 60 * 24 * 30.5));
  const ageInYears = Math.floor(ageInMilliseconds / (1000 * 60 * 60 * 24 * 365.25));

  return { age: ageInYears || ageInMonth, isMonth: !ageInYears, monthAreYear: ageInYears ? ' ans' : ' mois' }
}


export const dateFormateState = (date) => {
  var dateObject = new Date(date);

  // Format the date and time
  var day = dateObject.getDate();
  var month = dateObject.getMonth() + 1; // Adding 1 as months are 0-indexed
  var year = dateObject.getFullYear();
  var hours = dateObject.getHours();
  var minutes = dateObject.getMinutes();

  // Ensure the date and time components have two digits
  day = day < 10 ? '0' + day : day;
  month = month < 10 ? '0' + month : month;
  hours = hours < 10 ? '0' + hours : hours;
  minutes = minutes < 10 ? '0' + minutes : minutes;

  // Create the formatted string
  var formattedString = day + '/' + month + '/' + year + ' à ' + hours + ':' + minutes;

  return formattedString
}
export const toDisplayTime = (timeString) => {
  let time = parseInt(timeString)
  if (time < 60) {
    return time + " min";
  } else if (time < 1440) {
    let hours = time / 60;
    return hours.toFixed(2) + " hr";
  } else {
    let days = time / 1440;
    return (Math.round(days * 100) / 100) + " day";
  }
};

export const recursiveParse = (obj) => typeof obj === 'string' ? recursiveParse(JSON.parse(obj)) : obj

//  DD/MM/YYYY to 'YYYY-MM-DD'
export const convertDateFormat = (inputDate) => {
  const parts = inputDate.split('/');
  const [day, month, year] = inputDate.split('/').map(Number);
  const date = new Date(year, month - 1, day);
  if (date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day) {
    const formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
    return formattedDate;
  }
  else {
    return ''
  }
}

export const ignoreAccentPunc = (str) => {
  const ret = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
  // return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  return ret.replace(/[^a-zA-Z0-9]/g, " ")
}

/**
 * 
 * @param {*} date 
 * @returns 24.02.22 | 10:38
 */
export const dateToDateTimeString = (date) => {
  if (!date) {
    return "-"
  }
  var dateObject = new Date(date);

  var year = dateObject.getFullYear() % 100;
  var month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
  var day = dateObject.getDate().toString().padStart(2, '0');
  var hours = dateObject.getHours().toString().padStart(2, '0');
  var minutes = dateObject.getMinutes().toString().padStart(2, '0');


  var formattedDate = `${year}.${month}.${day} | ${hours}:${minutes}`;

  return formattedDate
}

export const isDateBetween = (targetDate, startDate, endDate) => {
  return targetDate >= startDate && targetDate <= endDate;
}

export function sequenceWithInterval(n, step, append, type = 'array') {
  n = n || 0;
  step = step || 1; // Default step is 1 if not provided
  append = append || ''
  var result = [];
  for (var i = step; i <= n; i += step) {
    if (type == 'array') result.push(i + ' ' + append);
    else result.push({ title: i + ' ' + append, numValue: i })
  }
  return result;
}

export function getEventCoordinates(e) {
  let target = e

  if (e.touches && e.touches.length) {
    target = e.touches[0]
  }

  return {
    clientX: target.clientX,
    clientY: target.clientY,
    x: target.pageX,
    y: target.pageY,
  }
}

export const withContext = (context, WrappedComponent) => {
  const ContextWrapper = (props) => {
    const contextProps = Array.isArray(context)
      ? context.reduce((acc, item) => ({ ...acc, [item.name]: item.context() }), {})
      : { [context.name]: context.context() };

    return <WrappedComponent {...contextProps} {...props} />;
  };

  return ContextWrapper;
};

export function isSameDate(date1, date2) {
  return date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate();
}

export function addHoursToTimeString([hour, mins], hoursToAdd) {
  const date = new Date()
  hour && date.setHours(hour)
  mins && date.setMinutes(mins)

  const initialDate = new Date(date);
  const newDate = new Date(initialDate.getTime() + (hoursToAdd * 60 * 60 * 1000));

  if (initialDate.getDate() !== newDate.getDate()) {
    // If the date changed, set the time to 23:59:59 of the initial date
    const endOfDay = new Date(initialDate);
    endOfDay.setHours(23, 59, 0, 0);
    // if hours to add is just one hour and the result still goes to next day then return null
    if (hoursToAdd == 1 && ((endOfDay - initialDate) < (60 * 60 * 1000))) {
      return null;
    }
    // Otherwise, set the time to 23:59 of the initial date
    newDate.setDate(initialDate.getDate());
    newDate.setHours(23, 59, 0, 0);
  }
  const hours = String(newDate.getHours()).padStart(2, '0');
  const minutes = String(newDate.getMinutes()).padStart(2, '0');

  return `${hours}:${minutes}`;
}

export const fileExtension = (url) => {
  // Remove query parameters or hash fragments
  const cleanUrl = url?.split?.('?')?.[0];
  // Extract the file extension
  const fileExtension = cleanUrl?.split?.('.')?.pop?.();
  return fileExtension?.toLowerCase?.();
}

export const isImage = (fileName) => {
  const validExtensions = new Set(['jpeg', 'jpg', 'png']);
  const ext = fileExtension(fileName);
  return validExtensions.has(ext);
};


export function isValidDOB(dateString = '') {
  const [day, month, year] = dateString.split('/').map(Number);
  const date = new Date(year, month - 1, day);

  // Get the current date
  const today = new Date();

  // Check if the date is valid and not in the future
  const isValid = date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
  const isNotInFuture = date <= today; // Ensure the date is not in the future

  return isValid && isNotInFuture;
}

export function isValidSSN(ssn, gender) {
  if (ssn == '' || ssn == undefined || ssn == null) {
    return true
  }
  const ssnRegex = gender == 1 ? ssn.startsWith('1') : gender == 2 ? ssn.startsWith('2') : false
  return ssnRegex && (ssn.length >= 13 && ssn.length <= 15)
}

export function isValidNumbersAndDots(value) {
  if (value == '' || value == undefined || value == null) {
    return true;
  }
  const numbersAndDotsRegex = /^\d+(?:\.\d+){7}$/;
  return numbersAndDotsRegex.test(value);
}


export function getNextMultipleOfFiveTime(now = new Date()) {
  const minutes = now.getMinutes(); // Get current minutes
  const nextMultiple = Math.ceil(minutes / 5) * 5; // Round up to the next multiple of 5

  // Set the time to the next multiple of 5 minutes
  now.setMinutes(nextMultiple, 0, 0); // Reset seconds and milliseconds to 0
  return now;
}


const FileViewStatic = {
  fileViewModel: 'file_viewer',
  imgB: 'image-block',
  iFrameB: 'ifram-block',
  imgSrc: 'iframe-img',
  pdfSrc: 'frame',
  btnPre: 'prev_icon',
  btnNext: 'next_icon',
  btnClose: 'close_btn',
  disableClassName: 'dis-button',
  previewOpen: 'preview-open',
  modalBackdrop: 'modal-backdrop',
}

export const GlobalLoaderActivate = (isShow = true) => {
  const loader = window.document.getElementById(RefId.appLoader)
  if (loader) {
    loader.style.display = isShow ? 'block' : 'none'
    loader.style.backgroundColor = isShow ? 'rgba(0, 0, 0, 0.3)' : undefined
  }
}

export const FileViewer = ({ filePath, fileType }) => {

  const fileViewModel = window.document.getElementById(FileViewStatic.fileViewModel)
  const imgBlock = window.document.getElementById(FileViewStatic.imgB)
  const iframeBlock = window.document.getElementById(FileViewStatic.iFrameB)
  const imgSrc = window.document.getElementById(FileViewStatic.imgSrc)
  const pdfSrc = window.document.getElementById(FileViewStatic.pdfSrc)
  const btnPre = window.document.getElementById(FileViewStatic.btnPre)
  const btnNext = window.document.getElementById(FileViewStatic.btnNext)
  const btnClose = window.document.getElementById(FileViewStatic.btnClose)

  btnPre.style.display = 'none'
  btnNext.style.display = 'none'
  btnPre.classList.add(FileViewStatic.disableClassName)
  btnNext.classList.add(FileViewStatic.disableClassName)


  switch (fileType) {
    case 'pdf':
      pdfSrc.src = filePath
      imgBlock.style.display = 'none'
      iframeBlock.style.display = 'block'
      break;
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'PNG':
      imgSrc.src = filePath
      imgBlock.style.display = 'flex'
      iframeBlock.style.display = 'none'
      break;
  }
  btnClose.onclick = () => {
    pdfSrc.src = ''
    fileViewModel.style.display = 'none'
    fileViewModel.classList.remove('show');
    if (filePath.includes('blob')) {
      URL.revokeObjectURL(filePath)
    }
  }

  fileViewModel.style.display = 'block'
  fileViewModel.classList.add('show');
}

export function getDateRange(view, date) {
  const momentDate = moment(date); // Convert input to a moment object

  switch (view) {
    case views.MONTH: {
      const startDate = momentDate.clone().startOf('month').startOf('week'); // Start of the week of the first day of the month
      const endDate = momentDate.clone().endOf('month').endOf('week'); // End of the week of the last day of the month
      return [startDate.toDate(), endDate.toDate()];
    }
    case views.WEEK: {
      const startDate = momentDate.clone().startOf('week'); // Start of the week
      const endDate = momentDate.clone().endOf('week'); // End of the week
      return [startDate.toDate(), endDate.toDate()];
    }
    case views.DAY: {
      return [momentDate.toDate(), momentDate.toDate()]; // Same date for start and end
    }
    case views.AGENDA: {
      const startDate = momentDate.clone();
      const endDate = momentDate.clone().add(30, 'days'); // Add 30 days to the start date
      return [startDate.toDate(), endDate.toDate()];
    }
    default: {
      const startDate = momentDate.clone().startOf('month').startOf('week'); // Start of the week of the first day of the month
      const endDate = momentDate.clone().endOf('month').endOf('week'); // End of the week of the last day of the month
      return [startDate.toDate(), endDate.toDate()]
    }
  }
}

export function getContrastTextColor(hexColor = '#FFFFFF') {
  let hex = hexColor?.replace('#', '');

  // Expand shorthand like #abc to #aabbcc
  if (hex?.length === 3) {
    hex = hex?.split('')?.map(c => c + c)?.join('');
  }

  const r = parseInt(hex?.slice(0, 2), 16);
  const g = parseInt(hex?.slice(2, 4), 16);
  const b = parseInt(hex?.slice(4, 6), 16);

  // Calculate luminance (relative brightness)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Return high contrast text color
  return luminance > 0.5 ? '#000000' : '#FFFFFF';
}

export function formatPhoneNumber(phonenumber, ph_cc = null, COUNTRY_CODE = "33") {
  if (!phonenumber) return "";

  let number = phonenumber.replace(/\D/g, ""); // remove all non-digit characters
  const len = number.length;

  ph_cc = ph_cc && ph_cc !== "" ? ph_cc.split("_")[0] : "";

  if (ph_cc === COUNTRY_CODE) {
    // France-specific formatting
    if (len === 10) {
      number = number.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, "$1 $2 $3 $4 $5");
    } else if (len === 9) {
      number = number.replace(/(\d{1})(\d{2})(\d{2})(\d{2})(\d{2})/, "$1 $2 $3 $4 $5");
    }
    number = number.replace(/^0+/, ""); // remove leading 0
  } else {
    // Other numbers
    if (len === 9) {
      number = number.replace(/(\d{3})(\d{6})/, "$1 $2");
    } else if (len === 10) {
      number = number.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, "$1 $2 $3 $4 $5");
    } else if (len === 11) {
      number = number.replace(/(\d{2})(\d{3})(\d{6})/, "$1 $2 $3");
    } else if (len === 12) {
      number = number.replace(/(\d{3})(\d{3})(\d{6})/, "$1 $2 $3");
    }
  }

  const prefix = ph_cc ? `+${ph_cc} ` : "";

  return prefix + number;
}

export function isAgendaOwner(agenda) {
  return (GetLoggedUserUUID() == GetOwnerOfLoggedMcUUID() || agenda?.doctor_id == GetLoggedUserUUID())
}

export function isAgendaFullAccess(agenda) {
  return (agenda?.sharing_access == AccessObj.full_access || isAgendaOwner(agenda))
}

export function isEventWriteAccess(agenda, event) {
  const createAccess = [AccessObj.manage_apt, AccessObj.full_access, AccessObj.only_create, AccessObj.apt_mng_message, AccessObj.apt_mng_dossier];
  const partialEditAccess = [AccessObj.only_create, AccessObj.apt_mng_message, AccessObj.apt_mng_dossier];
  const completeEditAccess = [AccessObj.full_access, AccessObj.manage_apt];
  if (event) {
    return ((partialEditAccess.includes(agenda?.sharing_access) && event?.created_by == GetLoggedUserID()) || completeEditAccess.includes(agenda?.sharing_access) || (GetLoggedUserUUID() == GetOwnerOfLoggedMcUUID()) || agenda?.doctor_id == GetLoggedUserUUID())
  } else {
    return (createAccess.includes(agenda?.sharing_access) || (GetLoggedUserUUID() == GetOwnerOfLoggedMcUUID()) || agenda?.doctor_id == GetLoggedUserUUID())
  }
}

export function isEventReadAccess(agenda, event) {
  const viewAccess = [AccessObj.full_access, AccessObj.manage_apt];
  const partialViewAccess = [AccessObj.only_create, AccessObj.apt_mng_message, AccessObj.apt_mng_dossier];
  return (viewAccess.includes(agenda?.sharing_access) || (GetLoggedUserUUID() == GetOwnerOfLoggedMcUUID()) || agenda?.doctor_id == GetLoggedUserUUID() || (event?.created_by == GetLoggedUserID() && partialViewAccess.includes(agenda?.sharing_access)))
}

export const isOnlyCreateAccess = (sharing_access) => {
  const onlyCreateAccess = [AccessObj.only_create, AccessObj.apt_mng_message, AccessObj.apt_mng_dossier];
  return (onlyCreateAccess.includes(sharing_access))
}

export const getUrlParams = (url, params) => {
  if (!url || !params || !Array.isArray(params)) {
    return {};
  }

  const urlObj = new URL(url);
  const paramObj = {};

  params.forEach(param => {
    paramObj[param] = urlObj.searchParams.get(param);
  });

  return paramObj;

}

/**
 * Check if any of the given ranges overlap with the target range.
 *
 * @param {Array} ranges - An array of objects with start and end of Date type properties.
 * @param {Object} target - An object with start and end properties.
 * @returns {boolean} True if any of the ranges overlap with the target, false otherwise.
 */
export const hasOverlapSlots = (ranges = [], target) => {
  return ranges.some(({ start, end }) => {
    return start < target.end && end > target.start
  })
}
